import React, { useState, useEffect } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import { Drawer, Divider, List, ListItem, ListItemText, useMediaQuery, IconButton, Button, Badge} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import SendData from "./generate";
import { useAuth } from "./firebase/AuthContext";
import { Link, useHistory } from "react-router-dom";
import MenuIcon from '@mui/icons-material/Menu';

import PlansScreen from "./paymentDrawer";
import Settings from "./settings"
import { firestore } from "./firebase/firebase";


const useStyles = makeStyles((theme) => ({
  drawer: {
    width: 240,
    flexShrink: 0,
  },
  drawerPaper: {
    width: 240,
    maxWidth: "100%",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  list: {
    paddingTop: theme.spacing(2),
    fontFamily: 'Inter',
    textAlign: 'center'
  }
}));




const ResponsiveDrawer = ({ selections, subscriptionSummaries, subscriptionSuggestions  }) => {
  const [selectionsRevised, setSelectionsRevised] = useState([]);
  const theme = useTheme();
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [error, setError] = useState("")
  const { currentUser, logout } = useAuth()
  const history = useHistory();

  const [subscription, setSubscription] = useState(null);
  
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleDelete = (index) => {
    selections.splice(index, 1);
    setSelectionsRevised([...selectionsRevised]);
  };

  const drawerVariant = useMediaQuery(theme.breakpoints.up('sm')) ? 'permanent' : 'temporary';
  const isMobile = useMediaQuery('(max-width: 600px)');

  async function handleLogout() {
    setError("")
    try {
      await logout()
    } catch {
      setError("Failed to log out")
    }
  };

  if (selections.length === 0) {

    return (
      <>
      <div>
      <div>
    {isMobile ? (
      <div>
                <MenuIcon  onClick={handleDrawerOpen} style={{padding: '10px', cursor:'pointer'}}/>

      </div>
    ) : (
      <div>
       
      </div>
    )}
  </div>
      </div>
      <Drawer
  variant={drawerVariant}
  open={open}
  onClose={handleDrawerClose}
  classes={{ paper: classes.drawerPaper }}
>
  <div style={{ display: "flex", justifyContent: "space-between", margin: '10px' }}>
    
  <Button onClick={()=>handleLogout()} style={{ color:'black',fontFamily: 'Inter', marginRight: '10px'}} >Logout</Button>
  <Settings/>
  </div>
  <div >
  <center>
  <PlansScreen />
  </center>

  <List className={classes.list}>
    <ListItem>
      <ListItemText primary="Summary" style={{textAlign: "center"}}/>
    </ListItem>
    <ListItem>
      <ListItemText secondary="Start to occupy the cells." style={{textAlign: "center"}}/>
    </ListItem>
    <ListItem>
      <ListItemText secondary="The chart is organised so you can track main thoughts and any off shoots." style={{textAlign: "center"}}/>
    </ListItem>
    <ListItem>
      <ListItemText secondary="Start to add thoughts to your list by clicking include." style={{textAlign: "center"}}/>
    </ListItem>
    <ListItem>
      <ListItemText secondary="Once a cell is occupied why not click suggestions to be handed a new ideas or thoughts." style={{textAlign: "center"}}/>
    </ListItem>
    <ListItem>
      <ListItemText secondary="Once you've collated 3 or more thoughts generate a easy to explain and understand definition of your thought processes." style={{textAlign: "center"}}/>
    </ListItem>
    <ListItem>
      <ListItemText secondary="Thoughts remain on this board even across projects in case you want to test ideas from different boards together." style={{textAlign: "center"}}/>
    </ListItem>
  </List>
  </div>
</Drawer>

      </>
    );

  } else {

    return (
      <>
        {isMobile ? (
      <div >
                <Badge badgeContent={selections.length} color="error" overlap="circular">
                <MenuIcon  onClick={handleDrawerOpen} style={{padding: '10px', cursor: 'pointer'}}/>
</Badge>

      </div>
    ) : (
      <div>
       
      </div>
    )}
        <Drawer
          variant={drawerVariant}
          open={open}
          onClose={handleDrawerClose}
          classes={{ paper: classes.drawerPaper }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", margin: '10px' }}>
  <Button onClick={()=>handleLogout()} style={{ color:'black',fontFamily: 'Inter', marginRight: '10px'}} >Logout</Button>
  <Settings/> 
</div>
<center>
  <PlansScreen />
  </center>

          {selections.length >= 3 && (
            <SendData selections={selections}/>
          )}
          <List>
            {selections.map((selection, index) => (
              <ListItem key={index}>
                <ListItemText primary={selection} />
                <IconButton
                  edge="end"
                  aria-label="delete"
                  onClick={() => handleDelete(index)}
                >
                  <DeleteIcon />
                </IconButton>
              </ListItem>
            ))}
          </List>
        </Drawer>
      </>
    );

  }
};

export default ResponsiveDrawer;


